import SpinnerIcon from 'components/icons/SpinnerIcon';
import { OrderData } from 'lib/bigcommerce/types';
import sanfordApi from 'lib/sanford-api';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { stringToCurrency } from 'utils/currency';
import OrderProductItem from './OrderProductItem';
import { formatDate } from 'utils/date';

interface OrderProps {
  order: OrderData;
  className?: string;
}

const Order: React.FC<OrderProps> = (props) => {
  const { order } = props;

  const [requestData, setRequestData] = useState(false);

  const orderQuery = useQuery(
    ['id', order.id],
    async () => {
      return sanfordApi.getCustomerOrder(order.id);
    },
    { enabled: requestData }
  );

  const orderDetails = orderQuery.data?.data?.result?.order;

  return (
    <>
      <div className="space-y-6 text-sf-blue-700">
        <div className="overflow-hidden rounded-md bg-sf-gray-100 p-6 text-base">
          <div className="flex flex-col gap-y-3">
            <div>
              <div className="flex flex-col gap-y-3 sm:gap-y-2">
                <div className="flex flex-col text-left">
                  <div className="relative  flex  w-full flex-col flex-nowrap items-start justify-between gap-1 gap-x-6 font-normal sm:flex-row">
                    <div className="text-left">Order No. {order.id}</div>
                    <div className="space-y-1 text-sm">
                      {order.dateCreated && (
                        <div className="md:text-right">
                          Order date {formatDate(order.dateCreated)}
                        </div>
                      )}
                      {order.deliveryDate && (
                        <div className="md:text-right">
                          Delivery date {formatDate(order.deliveryDate)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="relative flex w-full flex-row flex-nowrap items-start justify-between gap-x-6 text-sm font-normal">
                    <div className="text-left">
                      Items purchased. <span className="font-bold">({order.itemsTotal})</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {orderQuery.isLoading && !orderDetails && (
              <>
                <div className="flex justify-center py-6">
                  <SpinnerIcon className="animate-spin" />
                </div>
              </>
            )}
            {orderDetails && (
              <div className="relative w-full">
                <div>
                  <hr className="border-b border-sf-blue-700/5" />
                </div>
                <div className="mb-3">
                  {orderDetails.products?.map((product) => (
                    <OrderProductItem key={product.id} product={product} />
                  ))}
                </div>
              </div>
            )}
            {!orderQuery.isLoading && !orderDetails && (
              <button
                className="relative w-full text-sm font-medium"
                onClick={() => {
                  setRequestData(true);
                }}
              >
                <div className="absolute inset-0 rounded-md bg-sf-blue-700 opacity-5"></div>
                <div className="relative w-full py-2">Show full order</div>
              </button>
            )}
            <div className="relative w-full text-center">
              <span className="font-bold">Total</span>
              {` `}
              {stringToCurrency(order.priceTotal, order.currencyCode)}
              {order.shippingCostTotal && (
                <div className="text-xs">
                  Shipping cost of{` `}
                  {stringToCurrency(order.shippingCostTotal, order.currencyCode)} included
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Order;
